export const locales = [
  { languageShort: "En", languageLong: "English", tag: "EN" },
  { languageShort: "Zh", languageLong: "Chinese", tag: "ZH" },
  { languageShort: "Kr", languageLong: "Korean", tag: "KR" },
  { languageShort: "Jp", languageLong: "Japenese", tag: "JP" },
];
